import { render, staticRenderFns } from "./MemberFriendsView.vue?vue&type=template&id=654acf26&scoped=true"
import script from "./MemberFriendsView.vue?vue&type=script&lang=js"
export * from "./MemberFriendsView.vue?vue&type=script&lang=js"
import style0 from "./MemberFriendsView.vue?vue&type=style&index=0&id=654acf26&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "654acf26",
  null
  
)

export default component.exports